import { render } from "./WishCard.vue?vue&type=template&id=0d430da2"
import script from "./WishCard.vue?vue&type=script&lang=ts"
export * from "./WishCard.vue?vue&type=script&lang=ts"

import "./WishCard.vue?vue&type=style&index=0&id=0d430da2&lang=scss"
script.render = render

export default script